import { useContext, useEffect } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';
import { eventsRequest } from '../utils/eventsRequest';

const getSettings = async () => {
  try {
    const response = await eventsRequest('/client-settings', 'get');
    if (response.status === 200 && response.data) {
      return response.data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const useSettings = () => {
  const context = useContext(SettingsContext);

  useEffect(() => {
    if (context.loading) {
      if (window.location.pathname.includes('kids-co')) context.saveSettings([]);
      else
        getSettings()
          .then((data: any) => context.saveSettings(data.data))
          .catch((error) => {
            console.error('Failed to fetch settings:', error);
            context.saveSettings([]);
          });
    }
  }, [context.loading]);

  return { ...context.settings, loading: context.loading };
};

export default useSettings;
